import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';

export const CardContent = styled.div`
  padding: ${props => props.theme.space.s4} ${props => props.theme.space.s5};
  display: flex;
  align-items: center;
  & svg {
    margin-right: ${props => props.theme.space.s2};
  }
`;

export const CardBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseIconWrapper = styled(props => <CapsuleIcon {...props} />)`
  width: ${props => props.theme.space.s6};
  path {
    fill: ${props => props.theme.colors.capsuleBlue50} !important;
  }
`;
